<template>
  <div class="md-layout-item md-size-100">
    <div v-if="items && items.length > 0" class="md-layout-item md-size-100">
      <div
        class="md-layout-item md-layout md-gutter md-size-100 md-toolbar-section-end record-info-span"
      >
        <div class="md-layout-item md-size-100 text-align-end">
          <h4>Records: {{ items.length }}</h4>
        </div>
      </div>
    </div>

    <div v-if="items && items.length > 0" class="md-layout-item md-size-100">
      <md-table v-model="items" @md-selected="selectItem" md-card>
        <md-table-toolbar class="md-layout md-gutter md-size-100">
          <div class="md-layout-item md-size-100 md-toolbar-section-start">
            <h1 v-if="label && label.texts.length > 1" class="md-title">
              <span :class="label ? label.color : ''">{{
                label.texts[0]
              }}</span>
              {{ label.texts[1] }}
            </h1>
          </div>
        </md-table-toolbar>

        <md-table-row
          slot="md-table-row"
          slot-scope="{ item }"
          class="md-primary"
          md-selectable="single"
        >
          <md-table-cell
            :id="item.batchNo"
            class="font-16 line-height-20"
            :class="selectedItem(item)"
          >
            <div
              class="md-layout md-gutter md-size-100 font-size-16 text-align-start"
            >
              <div class="md-layout-item md-size-40">
                <span>{{ $t("disconnections.Batch") }}</span>
              </div>
              <div class="md-layout-item md-size-60">
                <span
                  class="display-important-info"
                  :class="label ? label.color : ''"
                  >{{ item.batchNo }}</span
                >
              </div>

              <div class="md-layout-item md-size-40">
                <span>{{ $t("ApplicationsGrid.description") }}</span>
              </div>
              <div class="md-layout-item md-size-60">
                <span
                  class="display-important-info"
                  :class="label ? label.color : ''"
                  >{{ item.description }}</span
                >
              </div>

              <div class="md-layout-item md-size-40">
                <span>{{ $t("captureMR.Records") }}</span>
              </div>
              <div class="md-layout-item md-size-60">
                <span
                  class="display-important-info"
                  :class="label ? label.color : ''"
                  >{{ item.records }}</span
                >
              </div>
            </div>
          </md-table-cell>
        </md-table-row>
      </md-table>
    </div>

    <div v-else class="md-layout-item md-size-100">
      <md-empty-state
        md-icon="format_color_reset"
        class="color-blue"
        :md-span="$t('common.NoResults')"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectBatcheList",
  props: {
    items: {
      type: Array,
      required: true,
    },
    selectItem: {
      type: Function,
      required: true,
    },
    selectedItemId: {
      type: Number,
      default: -1,
    },
    label: {
      type: Object,
      default: null,
    },
  },
  data: function () {
    return {};
  },
  methods: {
    selectedItem(item) {
      return this.selectedItemId == item.batchNo
        ? "background-color-gray_wached"
        : "";
    },
  },
};
</script>
<style>
.display-important-info {
  font-weight: bold;
}

.record-info-span {
  top: 95px;
  position: absolute;
  z-index: 5;
  right: 25px;
}
</style>
